<p-dialog
  #profileSearchModalWindow
  [(visible)]="showSearchModal"
  modal="true"
  [closable]="false"
  styleClass="atlas-dialog-l shadow-lg"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '70vh' }"
>
  <ng-template pTemplate="header">
    <div class="mct-flex mct-row w-100 pr-3">
      <h3 class="m-0 text-primary">
        <i class="pi pi-users mr-2"></i>
        {{ 'profiles.search.title-profile-selector' | translate | titlecase }}
      </h3>
      <div class="selected-badge shadow-sm" *ngIf="profileSearchComponentModel.selectedProfiles?.length">
        {{ profileSearchComponentModel.selectedProfiles.length }} {{ 'common.selected' | translate }}
      </div>
    </div>
  </ng-template>

  <div class="container-fluid pt-3">
    <div class="search-container bg-light p-3 rounded border mb-3">
      <div class="row align-items-center">
        <div class="col-sm-8 mb-10">
          <div class="p-inputgroup">
            <input
              pInputText
              [(ngModel)]="profileSearchComponentModel.searchParams.Keyword"
              type="text"
              class="form-control mr-5"
              [placeholder]="'profiles.search.keyword-placeholder' | translate"
              wl-on-enter-press
              (onEnterPess)="searchProfiles()"
            />

            <button
              pButton
              type="button"
              [disabled]="isSearching"
              class="atlas-btn atlas-btn-primary mr-5"
              (click)="searchProfiles()"
              icon="pi pi-search"
            ></button>

            <button pButton type="button" icon="pi pi-times" class="atlas-btn atlas-btn-secondary" (click)="clearProfiles()"></button>
          </div>
        </div>

        <div class="col-sm-4 text-right" [hidden]="!advancedSearchVisible || alwaysShowAdvancedSearch">
          <button
            pButton
            type="button"
            class="atlas-btn atlas-btn-secondary p-button-link p-button-sm font-weight-bold"
            (click)="profileSearchComponentModel.showAdvancedSearch ? handleHideAdvancedSearch() : handleShowAdvancedSearch()"
          >
            <i class="pi mr-1" [ngClass]="profileSearchComponentModel.showAdvancedSearch ? 'pi-chevron-up' : 'pi-sliders-h'"></i>
            {{ (profileSearchComponentModel.showAdvancedSearch ? 'common.hide' : 'common.advanced') | translate | titlecase }}
            {{ 'common.search' | translate | titlecase }}
          </button>
        </div>
      </div>

      <div class="mt-3 animate-fade-in" *ngIf="profileSearchComponentModel.showAdvancedSearch || alwaysShowAdvancedSearch">
        <wl-profile-advanced-search-options [searchParams]="profileSearchComponentModel.searchParams" (searchClicked)="searchProfiles()">
        </wl-profile-advanced-search-options>
      </div>
    </div>

    <div class="results-wrapper position-relative" [hidden]="!profileSelectorSearched">
      <p-table
        [showGridlines]="true"
        #profilesDataGrid
        [rows]="10"
        [value]="profileSearchComponentModel.profiles.Result"
        [paginator]="true"
        (onLazyLoad)="lazyLoadProfiles($event)"
        [totalRecords]="profileSearchComponentModel.profiles.TotalCount"
        [loading]="isSearching"
        [alwaysShowPaginator]="true"
        [lazy]="true"
        styleClass="wl-responsive-prime-datatable"
      >
        <ng-template pTemplate="header">
          <tr>
            <th class="text-center" style="width: 50px; background: #f8f9fa">
              <p-checkbox
                [(ngModel)]="profileSearchComponentModel.selectAllProfiles"
                binary="true"
                (ngModelChange)="onSelectAllChange($event)"
              ></p-checkbox>
            </th>
            <th pSortableColumn="ProfileId" class="text-center" style="width: 110px" *ngIf="showProfileId">
              ID <p-sortIcon field="ProfileId"></p-sortIcon>
            </th>
            <th pSortableColumn="ReportName" *ngIf="showReportName">
              {{ 'common.personal-information.profile-name' | translate | titlecase }} <p-sortIcon field="ReportName"></p-sortIcon>
            </th>
            <th *ngIf="showRelatedProfile" style="width: 180px">{{ 'profiles.search.related' | translate | titlecase }}</th>
            <th *ngIf="showMembershipLevel" style="width: 150px">{{ 'profiles.search.membership-level' | translate | titlecase }}</th>
            <th pSortableColumn="Email" *ngIf="showEmail">
              {{ 'common.personal-information.email-address' | translate | titlecase }} <p-sortIcon field="Email"></p-sortIcon>
            </th>
            <th pSortableColumn="EmailType" *ngIf="showEmailType" style="width: 120px">
              {{ 'profiles.search.email-type' | translate | titlecase }} <p-sortIcon field="EmailType"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [ngClass]="{ 'bg-primary-light': item.Selected }">
            <td class="text-center">
              <p-checkbox [(ngModel)]="item.Selected" binary="true" (ngModelChange)="onProfileSelectedChange(item)"></p-checkbox>
            </td>
            <td class="text-center font-weight-bold text-muted small" *ngIf="showProfileId">{{ item.ProfileId }}</td>
            <td *ngIf="showReportName">
              <div class="mct-flex mct-row">
                <wl-profile-type-icon
                  *ngIf="item && item.ProfileId"
                  [isMember]="item.Member"
                  [isOrg]="item.OrgInd"
                  [profileId]="item.ProfileId"
                  [memberTypeIconColor]="item.MemberTypeIconColor"
                >
                </wl-profile-type-icon>
                <span class="ml-2 font-weight-bold">{{ item.ReportName }}</span>
              </div>
            </td>
            <td *ngIf="showRelatedProfile" class="small">
              {{ item.MainContact || item.RelatedOrg || '--' }}
            </td>
            <td *ngIf="showMembershipLevel">
              <span class="badge badge-light border">{{ item.MembershipLevel }}</span>
            </td>
            <td *ngIf="showEmail" class="small text-truncate" style="max-width: 150px" [title]="item.Email">
              {{ item.Email }}
            </td>
            <td *ngIf="showEmailType">
              <span class="text-muted small">{{ item.EmailType }}</span>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="footer">
          <tr *ngIf="profileSearchComponentModel.profiles.TotalCount > 0">
            <td [attr.colspan]="columnCount" class="bg-light py-2">
              <div class="text-right text-muted small italic pr-3">
                {{ 'profiles.search.total-profiles' | translate | titlecase }}:
                <strong>{{ profileSearchComponentModel.profiles.TotalCount }}</strong>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-justify-between mct-items-center w-100 p-2">
      <div class="text-muted small italic ml-2" *ngIf="!profileSelectorSearched">
        <i class="pi pi-info-circle mr-1"></i> {{ 'common.enter-keyword-to-search' | translate | ucfirst }}
      </div>
      <div *ngIf="profileSelectorSearched"></div>
      <div class="mct-flex mct-row mct-gap-10">
        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-secondary"
          (click)="showSearchModal = false"
          icon="pi pi-times"
          [label]="'common.cancel' | translate | titlecase"
        ></button>

        <button
          pButton
          type="button"
          class="atlas-btn atlas-btn-primary"
          (click)="selectProfiles()"
          [disabled]="loading.busy"
          icon="pi pi-check"
          [label]="'common.select' | translate | titlecase"
        ></button>
      </div>
    </div>
  </ng-template>
</p-dialog>
